// Auth events that Amplify Hub can generate as user auth status changes
export enum AuthEvent {
  SIGNIN = 'signIn',
  SIGNUP = 'signUp',
  SIGNOUT = 'signOut',
  SIGNIN_FAILURE = 'signIn_failure',
  TOKEN_REFRESH = 'tokenRefresh',
  TOKEN_REFRESH_FAILURE = 'tokenRefresh_failure',
  CONFIGURED = 'configured',
}

// These are our additions the Amplify built in codes.  We cannot use the "auth" channel for
// them since that is a protected internal channel for Amplify.
export enum CustomAuthEvent {
  SIGNUP_CONFIRM = 'confirmed', // This will always be by phone (so also is phone number confirm)
  EMAIL_CONFIRM = 'email_confirmed',
}
